"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var SubmitButton = function (props) {
    var onClick = props.onClick, _a = props.label, label = _a === void 0 ? 'Update' : _a;
    return (react_1["default"].createElement(Button_1["default"], { variant: "contained", color: "primary", size: "large", onClick: onClick, type: "submit" }, label));
};
exports["default"] = SubmitButton;
